import { render, staticRenderFns } from "./ThuxTableChecksComponent.vue?vue&type=template&id=850e553c&"
import script from "./ThuxTableChecksComponent.vue?vue&type=script&lang=js&"
export * from "./ThuxTableChecksComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports